import {
  BookkeepersCompanyIncidenceStatsDocument,
  BookkeepersManagementUpdateIncidenceStatusDocument,
  BookkeepersManagementUpdateIncidenceStatusMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

interface QueryParameters {
  incidenceId: number
  newIncidenceStatus: string
}

export type UpdateIncidenceStatusPayload =
  BookkeepersManagementUpdateIncidenceStatusMutation['bookkeepersManagementMutations']['updateBookkeepersmanagementIncidence']

export const useUpdateIncidenceStatus = () => {
  const isBookkeeperView = useBookkeeperView()
  const [updateIncidenceStatus, { loading }] = useMutation(
    BookkeepersManagementUpdateIncidenceStatusDocument,
    {
      context: {
        isBookkeeperView,
      },
      extractorFn: (data: BookkeepersManagementUpdateIncidenceStatusMutation) => ({
        ...data.bookkeepersManagementMutations.updateBookkeepersmanagementIncidence,
        errors: [],
      }),
      refetchQueries: [BookkeepersCompanyIncidenceStatsDocument],
    }
  )

  return {
    // Maybe awaitRefetchQueries is needed here
    update(params: QueryParameters) {
      return updateIncidenceStatus({ variables: params })
    },
    loading,
  }
}
